import React, { useMemo, useRef } from 'react';
import styles from './assets/program-book-seance.module.scss';
import classNames from 'classnames';
import ProgramBookAnswerForm from './ProgramBookAnswerForm';
import { groupProgramBookEntity } from '../../../../../../../ProgramBook/screens/ProgramBookUpdate/helper.groupProgramEntity';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../../../../../../store/reducers';
import { groupProgramAnswerEntity } from 'src/helpers/programBook/helperAnswer';
import { useEffect, useState } from 'react';
import { getFormValues, initialize } from 'redux-form';
import {
    asyncPersistProgramBookAnswer,
    asyncPersistProgramBookAnswerOfTarget,
} from 'src/store/actions/program-book-actions';

export interface Props {
    setLoader: (it: boolean) => void;
    setIsChangedProgramBook: (it: boolean) => void;
    studentId: any;
    programBookAnswers?: any;
    inProgressAnswers?: boolean;
}

const ProgramBookSession: React.FunctionComponent<Props> = ({
    setLoader,
    setIsChangedProgramBook,
    studentId,
    programBookAnswers: programBookAnswersFromProps,
    inProgressAnswers: inProgressAnswersFromProps,
}) => {
    // const inProgressAnswers = useSelector((state: StoreState) => state.programBookAnswers.inProgressAnswers);
    const programBook = useSelector((state: StoreState) => state.programBooks);
    const seance = useSelector((state: StoreState) => state.seances.current);
    const current = programBook.data.list?.length ? programBook.data.list[0] : null;
    //const programBookAnswers = useSelector((state: StoreState) => state.programBookAnswers);

    const programBookAnswersRedux = useSelector((state: StoreState) => state.programBookAnswers);
    const inProgressAnswersRedux = useSelector((state: StoreState) => state.programBookAnswers.inProgressAnswers);

    const programBookAnswers = programBookAnswersFromProps ?? programBookAnswersRedux;
    const inProgressAnswers = inProgressAnswersFromProps ?? inProgressAnswersRedux;


    const dispatch = useDispatch();
    // Tracks the last list reference used to initialize the form.
    // Form re-initializes only when the data source itself changes (e.g. after a post-save refetch).
    const lastInitListRef = useRef<any>(null);
    const state = useSelector((state: StoreState) => state);
    const [isChangeValue, setIsChangeValue] = useState<boolean>(false);
    const [isManualChangeValue, setIsManualChangeValue] = useState<boolean>(false);
    const [targetManualChangeValue, setTargetManualChangeValue] = useState<string>('');
    const [dataChanged, setDataChanged] = useState([]);
    const [isDataChanged, setIsDataChanged] = useState(false);

    const pgValuesForm = getFormValues('program-book')(state);

    const initialValues = useMemo(() => {
        let dataBook: any = {};
        let dataBookAnswers: any = {};
        if (current) {
            dataBook = groupProgramBookEntity(current);
        }
        if (programBookAnswers?.data?.list) {
            dataBookAnswers = groupProgramAnswerEntity(dataBook, programBookAnswers, seance?.seanceDate || '');
        }
        return { ...dataBook, ...dataBookAnswers, seanceId: seance?.id };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [programBookAnswers?.data?.list, current, seance?.id]);

    // Re-initialize the form when the data source changes (e.g. after post-save refetch).
    // keepDirty=true on re-init preserves any user edits made after the first load.
    useEffect(() => {
        if (!current) return;
        const currentList = programBookAnswers?.data?.list;
        if (lastInitListRef.current === currentList) return;
        const isReInit = lastInitListRef.current !== null;
        lastInitListRef.current = currentList;
        dispatch(initialize('program-book', initialValues, isReInit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValues]);

    useEffect(() => {
        if (isManualChangeValue) {
            setIsChangedProgramBook(true);
        }
    }, [setIsManualChangeValue, isManualChangeValue]);

    const pgValuesFormRef = useRef<any>(null);
    pgValuesFormRef.current = pgValuesForm;
    const targetManualChangeValueRef = useRef<string>('');
    targetManualChangeValueRef.current = targetManualChangeValue;

    const prevInProgressRef = useRef<boolean>(false);
    useEffect(() => {
        const justFinished = prevInProgressRef.current === true && inProgressAnswers === false;
        prevInProgressRef.current = inProgressAnswers ?? false;
        if (justFinished && isChangeValue) {
            setIsChangeValue(false);
            const target = targetManualChangeValueRef.current;
            if (target) {
                asyncPersistProgramBookAnswerOfTarget(pgValuesFormRef.current, target, dispatch);
            } else {
                asyncPersistProgramBookAnswer(pgValuesFormRef.current, dispatch);
            }
        }
    }, [inProgressAnswers]);

    if (!current) {
        return <div className={classNames(styles.wrapContent, 'mb-3')} />;
    }

    return (
        <div className={classNames(styles.wrapContent, 'mb-3')}>
            <ProgramBookAnswerForm
                setLoader={setLoader}
                studentId={studentId}
                setDataChanged={setDataChanged}
                setIsDataChanged={setIsDataChanged}
                setIsChangeValue={setIsChangeValue}
                setIsManualChangeValue={setIsManualChangeValue}
                setTargetManualChangeValue={setTargetManualChangeValue}
                isChangeValue={isChangeValue}
                isManualChangeValue={isManualChangeValue}
                targetManualChangeValue={targetManualChangeValue}
                inProgressAnswers={inProgressAnswers}
                programBookId={current?.id}
                dataBookAnswers={{ ...{ seanceId: seance?.id }, ...pgValuesForm }}
                initialValues={initialValues}
            />
        </div>
    );
};
export default ProgramBookSession;
